import { render, staticRenderFns } from "./span-table.vue?vue&type=template&id=ab43afae&scoped=true"
import script from "./span-table.vue?vue&type=script&lang=js"
export * from "./span-table.vue?vue&type=script&lang=js"
import style0 from "./span-table.vue?vue&type=style&index=0&id=ab43afae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab43afae",
  null
  
)

export default component.exports